import React from 'react';
import { connect } from 'react-redux';
import { FormattedErrors } from 'type';
import { ErrorBox } from 'element';
import { StoreState } from 'state/types';
import {
  BOX_UNAVAILABILITY_CLEAR_ERRORS,
  getErrors
} from 'state/ManagerDashboard/Unavailability';

type OwnProps = {};

type StateProps = {
  errors: FormattedErrors;
};

type DispatchProps = {
  clearErrors: () => void;
};

type Props = OwnProps & StateProps & DispatchProps;

const UnavailabilityErrorBoxComponent = (props: Props) => (
  <ErrorBox {...props} />
);

const mapStateToProps = (state: StoreState): StateProps => ({
  errors: getErrors(state)
});

const mapDispatchToProps: DispatchProps = {
  clearErrors: BOX_UNAVAILABILITY_CLEAR_ERRORS
};

export const UnavailabilityErrorBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(UnavailabilityErrorBoxComponent);
